export const entrypoint = window.Cypress ? window.Cypress.env('REACT_APP_API_ENTRYPOINT') : process.env.REACT_APP_API_ENTRYPOINT
export const baseUrl = window.Cypress ? window.Cypress.env('REACT_APP_API_BASEURL') : process.env.REACT_APP_API_BASEURL
